'use strict';

var react = require('react');
var Bowser = require('bowser');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var Bowser__default = /*#__PURE__*/_interopDefaultCompat(Bowser);

/**
 * Use Browser Hook.
 */ const useBrowser = ()=>{
    const [browser, setBrowser] = react.useState();
    /**
     * Since we are using `useEffect` it will execute the browser detection only
     * on client side apps, so it won't fail on apps with server side rendering.
     */ react.useEffect(()=>{
        if (!browser) {
            const parser = Bowser__default.default.getParser(window.navigator.userAgent);
            const browserName = parser.getBrowserName();
            setBrowser({
                isSafari: browserName === Bowser__default.default.BROWSER_MAP.safari,
                isFirefox: browserName === Bowser__default.default.BROWSER_MAP.firefox
            });
        }
    }, [
        browser
    ]);
    return {
        browser
    };
};

exports.useBrowser = useBrowser;
//# sourceMappingURL=useBrowser.js.map
